import { useQuoteXp } from '@/hooks/usePospHub';

/**
 * Messaging Plan 2 — what this option would earn the agent, as XP (IRDAI allows
 * no commission figure on screen). Mounted ONLY for posp / super_posp; the data
 * comes from its own agent-scoped endpoint, so no shared quote serializer ever
 * carries XP. A failed fetch reads "XP unavailable", never "+0 XP".
 */
export function ProjectedXpBadge({ quoteRequestId, quoteId }: { quoteRequestId: string; quoteId?: string }) {
  const { data, isLoading, isError } = useQuoteXp(quoteRequestId);
  if (!quoteId) return null;
  if (isLoading) {
    return (
      <span aria-busy="true" className="text-xs text-gray-400 dark:text-gray-500">
        XP…
      </span>
    );
  }
  const label = isError ? 'XP unavailable' : data?.find((p) => p.quote_id === quoteId)?.label ?? 'XP pending';
  return (
    <span
      data-testid={`xp-${quoteId}`}
      title="Shown only to you. Customers never see XP."
      className="inline-flex items-center rounded-full bg-violet-100 px-2.5 py-0.5 text-xs font-semibold text-violet-800 dark:bg-violet-900/40 dark:text-violet-200"
    >
      {label}
    </span>
  );
}
